export default "/images/678888a727a1827e110d158eeef1e176.avif";